import type {ReactElement} from 'react';
import {useAppSelector} from '@/hooks';
import {Icon} from '@Components/icon-v2';
import {FlatIconColor, FlatIconColorType, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text';
import type {CheckoutStepProps} from '@Components/checkout-flow/checkout-flow.types';
import styles from './checkout-error-step.module.scss';

export function CheckoutErrorStep(_props: CheckoutStepProps): ReactElement {
  const errorTitle = useAppSelector((state) => state.checkoutFlow.errorTitle);
  const errorMessage = useAppSelector((state) => state.checkoutFlow.errorMessage);

  return (
    <div className={styles.container}>
      <Icon icon="icon-exclamation-triangle" size={IconSize.SIZE_ICON_48} type={IconType.FLAT} flatIconType={{color: FlatIconColor.DANGER, type: FlatIconColorType.DARK}} ariaHidden />
      <Text val={errorTitle} size={TextSize.LG} bold className={`content-heading ${styles.title}`} />
      <Text val={errorMessage} size={TextSize.LG} className="content-body" dangerouslySetInnerHTML />
    </div>
  );
}
